import React, { useState, useEffect } from 'react';
import s from './TeacherThemes.module.css';
import qs from './TeacherQuestions.module.css';

const EMPTY_FORM = {
  savol_uz: '', savol_ru: '', savol_en: '',
  javob_uz: '', javob_ru: '', javob_en: '',
  nazariy: false,
  gruhs: [],
};

export const TeacherQuestions = () => {
  const token = localStorage.getItem('token');

  const [questions, setQuestions] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('list'); // 'list' | 'form'
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [deleteId, setDeleteId] = useState(null);
  const [activeTab, setActiveTab] = useState('uz');
  const [filterGroup, setFilterGroup] = useState('');

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [qRes, gRes] = await Promise.all([
        fetch('https://api.aiassessment.uz/api/kurs-yozma-savol/?kurs=2', {
          headers: { Authorization: `Token ${token}` },
        }),
        fetch('https://api.aiassessment.uz/api/gruh/', {
          headers: { Authorization: `Token ${token}` },
        }),
      ]);
      const qData = await qRes.json();
      const gData = await gRes.json();
      setQuestions(Array.isArray(qData) ? qData : []);
      setGroups(Array.isArray(gData) ? gData : []);
    } catch {
      setError("Ma'lumotlarni yuklashda xatolik");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAll(); }, []);

  const openCreate = () => {
    setForm(EMPTY_FORM);
    setEditingId(null);
    setError('');
    setSuccess('');
    setActiveTab('uz');
    setView('form');
  };

  const openEdit = (q) => {
    setForm({
      savol_uz: q.savol_uz ?? '', savol_ru: q.savol_ru ?? '', savol_en: q.savol_en ?? '',
      javob_uz: q.javob_uz ?? '', javob_ru: q.javob_ru ?? '', javob_en: q.javob_en ?? '',
      nazariy: q.nazariy ?? false,
      gruhs: Array.isArray(q.gruhs) ? q.gruhs : [],
    });
    setEditingId(q.id);
    setError('');
    setSuccess('');
    setActiveTab('uz');
    setView('form');
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const toggleGroup = (id) => {
    setForm(prev => ({
      ...prev,
      gruhs: prev.gruhs.includes(id)
        ? prev.gruhs.filter(g => g !== id)
        : [...prev.gruhs, id],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');

    const body = {
      kurs: 2,
      savol_uz: form.savol_uz,
      savol_ru: form.savol_ru,
      savol_en: form.savol_en,
      javob_uz: form.javob_uz,
      javob_ru: form.javob_ru,
      javob_en: form.javob_en,
      nazariy: form.nazariy,
      gruhs: form.gruhs,
    };

    try {
      const url = editingId
        ? `https://api.aiassessment.uz/api/kurs-yozma-savol/${editingId}/`
        : 'https://api.aiassessment.uz/api/kurs-yozma-savol/';
      const method = editingId ? 'PATCH' : 'POST';

      const res = await fetch(url, {
        method,
        headers: {
          Authorization: `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const err = await res.json();
        setError(JSON.stringify(err));
      } else {
        setSuccess(editingId ? 'Savol yangilandi!' : 'Savol qo\'shildi!');
        await fetchAll();
        setTimeout(() => setView('list'), 1200);
      }
    } catch {
      setError('Server bilan bog\'lanishda xatolik');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      await fetch(`https://api.aiassessment.uz/api/kurs-yozma-savol/${deleteId}/`, {
        method: 'DELETE',
        headers: { Authorization: `Token ${token}` },
      });
      setDeleteId(null);
      await fetchAll();
    } catch {
      setError('O\'chirishda xatolik');
    }
  };

  const getGroupNames = (gruhs) =>
    gruhs.map(id => groups.find(g => g.id === id)?.nomi ?? `#${id}`).join(', ');

  const filtered = filterGroup
    ? questions.filter(q => q.gruhs?.includes(Number(filterGroup)))
    : questions;

  const tabs = [
    { key: 'uz', label: 'UZ' },
    { key: 'ru', label: 'RU' },
    { key: 'en', label: 'EN' },
  ];

  return (
    <div className={s.page}>
      <div className={s.header}>
        <h1 className={s.title}>Yozma savollar boshqaruvi</h1>
        {view === 'list' ? (
          <button className={s.btnPrimary} onClick={openCreate}>+ Yangi savol</button>
        ) : (
          <button className={s.btnSecondary} onClick={() => setView('list')}>← Ro'yxatga qaytish</button>
        )}
      </div>

      {view === 'list' && (
        <>
          {/* Фильтр по группе */}
          <div className={qs.filterRow}>
            <label className={qs.filterLabel}>Guruh bo'yicha filter:</label>
            <select
              className={qs.filterSelect}
              value={filterGroup}
              onChange={e => setFilterGroup(e.target.value)}
            >
              <option value="">Barcha guruhlar</option>
              {groups.map(g => (
                <option key={g.id} value={g.id}>{g.nomi}</option>
              ))}
            </select>
            <span className={qs.countBadge}>{filtered.length} ta savol</span>
          </div>

          {loading ? (
            <p className={s.loading}>Yuklanmoqda...</p>
          ) : (
            <div className={s.tableWrapper}>
              <table className={s.table}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Turi</th>
                    <th>Savol (UZ)</th>
                    <th>Guruhlar</th>
                    <th>Amallar</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.length === 0 && (
                    <tr><td colSpan={5} style={{ textAlign: 'center', color: '#888' }}>Savollar yo'q</td></tr>
                  )}
                  {filtered.map((q, idx) => (
                    <tr key={q.id}>
                      <td>{idx + 1}</td>
                      <td>
                        <span className={`${qs.typeBadge} ${q.nazariy ? qs.theory : qs.practice}`}>
                          {q.nazariy ? 'Nazariy' : 'Amaliy'}
                        </span>
                      </td>
                      <td className={s.tdTitle}>
                        {q.savol_uz?.slice(0, 80)}{q.savol_uz?.length > 80 ? '…' : ''}
                      </td>
                      <td className={qs.tdGroups}>
                        {q.gruhs?.length > 0
                          ? getGroupNames(q.gruhs)
                          : <span className={qs.noGroup}>—</span>}
                      </td>
                      <td className={s.tdActions}>
                        <button className={s.btnEdit} onClick={() => openEdit(q)}>✏️</button>
                        <button className={s.btnDelete} onClick={() => setDeleteId(q.id)}>🗑</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {view === 'form' && (
        <form className={s.form} onSubmit={handleSubmit}>
          <h2 className={s.formTitle}>
            {editingId ? 'Savolni tahrirlash' : 'Yangi savol qo\'shish'}
          </h2>

          {/* Tur va guruhlar */}
          <div className={qs.topRow}>
            <div className={qs.typeToggle}>
              <span className={qs.typeLabel}>Savol turi:</span>
              <label className={`${qs.typeBtn} ${!form.nazariy ? qs.typeBtnActive : ''}`}>
                <input type="radio" name="nazariy" value="false"
                  checked={!form.nazariy}
                  onChange={() => setForm(p => ({ ...p, nazariy: false }))} />
                Amaliy
              </label>
              <label className={`${qs.typeBtn} ${form.nazariy ? qs.typeBtnActive : ''}`}>
                <input type="radio" name="nazariy" value="true"
                  checked={form.nazariy}
                  onChange={() => setForm(p => ({ ...p, nazariy: true }))} />
                Nazariy
              </label>
            </div>

            <div className={qs.groupPicker}>
              <span className={qs.typeLabel}>Guruhlar:</span>
              <div className={qs.groupList}>
                {groups.map(g => (
                  <label
                    key={g.id}
                    className={`${qs.groupChip} ${form.gruhs.includes(g.id) ? qs.groupChipActive : ''}`}
                  >
                    <input
                      type="checkbox"
                      checked={form.gruhs.includes(g.id)}
                      onChange={() => toggleGroup(g.id)}
                      style={{ display: 'none' }}
                    />
                    {g.nomi}
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* Язык табы */}
          <div className={s.langTabs}>
            {tabs.map(tab => (
              <button
                key={tab.key}
                type="button"
                className={`${s.langTab} ${activeTab === tab.key ? s.langTabActive : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {tabs.map(tab => (
            <div key={tab.key} className={activeTab === tab.key ? s.tabContent : s.tabHidden}>
              <div className={s.field}>
                <label>Savol matni ({tab.label})</label>
                <textarea
                  name={`savol_${tab.key}`}
                  value={form[`savol_${tab.key}`]}
                  onChange={handleChange}
                  className={s.textarea}
                  rows={4}
                  placeholder="Savol matnini kiriting..."
                />
              </div>
              <div className={s.field}>
                <label>Namunaviy javob ({tab.label})</label>
                <textarea
                  name={`javob_${tab.key}`}
                  value={form[`javob_${tab.key}`]}
                  onChange={handleChange}
                  className={`${s.textarea} ${qs.codeArea}`}
                  rows={10}
                  placeholder="Namunaviy javob yoki kod..."
                  spellCheck={false}
                />
              </div>
            </div>
          ))}

          {error && <p className={s.error}>{error}</p>}
          {success && <p className={s.successMsg}>{success}</p>}

          <div className={s.formActions}>
            <button type="submit" className={s.btnPrimary} disabled={saving}>
              {saving ? 'Saqlanmoqda...' : (editingId ? 'Yangilash' : 'Saqlash')}
            </button>
            <button type="button" className={s.btnSecondary} onClick={() => setView('list')}>
              Bekor qilish
            </button>
          </div>
        </form>
      )}

      {/* Удаление */}
      {deleteId && (
        <div className={s.modalOverlay}>
          <div className={s.modal}>
            <h3>Savolni o'chirish</h3>
            <p>Haqiqatan ham bu savolni o'chirmoqchimisiz?</p>
            <div className={s.modalActions}>
              <button className={s.btnDelete} onClick={handleDelete}>O'chirish</button>
              <button className={s.btnSecondary} onClick={() => setDeleteId(null)}>Bekor qilish</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
